import React from "react";
import "../../styles/LegalWindow.css";
import closeButton from "../../assets/images/close.png";

const LegalWindow = ({ onClose }) => {
    return (
        <div className="legal-window">
            <div className="legal-header">
                <span>Legal</span>
                <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer" }}>
                <img src={closeButton} alt="Close" style={{ width: "24px", height: "auto" }} />
                </button>
            </div>

            <div className="legal-content">
                <h2>Legal Notice</h2>

                <h3>Website Publisher</h3>
                <p>
                    The website <strong>akalexmusic.com</strong> is published by the artist Akalex
                    (real name: Alex Spenlé), whose primary working address is:
                </p>
                <address>
                    8, rue Antoine Herzog, 68200 MULHOUSE, France
                    <br />
                    <strong>Contact:</strong> <a href="mailto:contact@akalexmusic.com">contact@akalexmusic.com</a>
                </address>

                <h3>Website Design and Development</h3>
                <p>
                    The website was designed and developed by Ramsford Sheamang, CEO of DEMNA (SIRET: 91334211900017).
                </p>
                <p>
                    <strong>Contact:</strong>{" "}
                    <a href="mailto:contact@ramsford.fr">contact@ramsford.fr</a>
                </p>

                <h3>Hosting</h3>
                <address>
                    The website is hosted by OVH, a company based in France:
                    <ul>
                        <li>Headquarters: 2 rue Kellermann, 59100 Roubaix, France</li>
                        <li>Website: <a href="https://www.ovh.com" target="_blank" rel="noreferrer">www.ovh.com</a></li>
                    </ul>
                </address>

                <h3>Intellectual Property</h3>
                <p>
                    All music on <strong>akalexmusic.com</strong> is the original work of the artist Akalex. Any reproduction,
                    distribution, or modification without prior authorization is prohibited and constitutes a violation
                    of copyright laws.
                </p>

                <h3>Liability</h3>
                <p>
                    Akalex strives to provide accurate information on the website <strong>akalexmusic.com</strong>. However,
                    no guarantees are made regarding the absence of errors or omissions. The artist cannot be held liable
                    for any damages resulting from the use of the website.
                </p>

                <h2>Privacy Policy</h2>

                <h3>Data Controller</h3>
                <p>
                    The processing of personal data collected on <strong>akalexmusic.com</strong> is managed by Alex Spenlé,
                    also known as Akalex.
                </p>
                <address>
                    Address: 8, rue Antoine Herzog, 68200 MULHOUSE, France
                    <br />
                    <strong>Contact:</strong>{" "}
                    <a href="mailto:contact@akalexmusic.com">contact@akalexmusic.com</a>
                </address>

                <h3>Data Collected and Purpose</h3>
                <ul>
                    <li>
                        <strong>User Interactions:</strong> Likes for songs (sent and stored via Firebase).
                    </li>
                    <li>
                        <strong>Locally Stored Data:</strong> Likes are also saved in the user’s localStorage.
                    </li>
                </ul>
                <p>
                    This data is used exclusively for:
                    <ul>
                        <li>Tracking user interactions with the music available on the website.</li>
                        <li>Enhancing the user experience by personalizing the display based on preferences.</li>
                    </ul>
                </p>

                <h3>Legal Basis</h3>
                <p>
                    The processing of data is based on the user’s consent, which is freely given when choosing to like a song.
                </p>

                <h3>Data Hosting</h3>
                <p>
                    Data related to likes is stored on Firebase, a platform by Google. Firebase complies with European security
                    standards and hosts its data within the European Economic Area (EEA) or in the United States under standard
                    contractual clauses.
                </p>

                <h3>Data Retention</h3>
                <ul>
                    <li>Likes are stored on Firebase for a maximum of 12 months after they are recorded.</li>
                    <li>Data saved in localStorage remains indefinitely or until the user manually clears their browser history.</li>
                </ul>

                <h3>User Rights</h3>
                <p>
                    In accordance with the General Data Protection Regulation (GDPR), users have the following rights:
                </p>
                <ul>
                    <li><strong>Right of Access:</strong> Request a copy of the data collected about them.</li>
                    <li><strong>Right to Rectification:</strong> Correct inaccurate data.</li>
                    <li><strong>Right to Erasure:</strong> Request the deletion of data stored on Firebase.</li>
                    <li><strong>Right to Object:</strong> Refuse the processing of their data for specific purposes.</li>
                </ul>
                <p>
                    To exercise these rights, users can contact:{" "}
                    <a href="mailto:contact@akalexmusic.com">contact@akalexmusic.com</a>
                </p>

                <h3>Cookies and LocalStorage</h3>
                <p>
                    The website uses the browser’s localStorage to locally store likes on the user’s device.
                    This data is accessible only to the user and is not automatically shared with third parties.
                </p>

                <h3>Data Security</h3>
                <p>
                    The website <strong>akalexmusic.com</strong> implements technical and organizational measures to protect
                    user data against unauthorized access, loss, or alteration.
                </p>

                <h3>Policy Updates</h3>
                <p>
                    This privacy policy may be updated at any time to reflect legal or technical changes. In case of
                    significant modifications, users will be notified via a message on the website.
                </p>
            </div>
        </div>
    );
};

export default LegalWindow;